<template>
  <div
    class="modal fade"
    id="shopperApprovalModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.SAM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-center" style="width: 15%">
                    {{ lang.SAM003 }}
                  </th>
                  <th class="text-center" style="width: 15%">
                    {{ lang.SAM004 }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <!-- Lead column -->
                    <div class="form-group" v-if="!(globals.isLeadAgencyUser && allChecksAreLeadAgencyPlus && userAgencyEqualsCheckAgency)">
                      <select
                        class="form-control"
                        v-model="leadAgencyApproval"
                        :disabled="highestSurveyInstanceStatusId > 200"
                        @change="updateApprovalState('leadAgency')"
                        :class="{
                          'option-green': leadAgencyApproval === 'Approved',
                          'option-red': leadAgencyApproval === 'Rejected',
                          'option-yellow': leadAgencyApproval === undefined,
                        }"
                      >
                        <option :value="null"></option>
                        <option class="option-green" :value="'Approved'">
                          {{ lang.SAM022 }}
                        </option>
                        <option class="option-yellow" :value="undefined">
                          {{ lang.SAM023 }}
                        </option>
                        <option class="option-red" :value="'Rejected'">
                          {{ lang.SAM024 }}
                        </option>
                      </select>
                    </div>
                  </td>
                  <td>
                    <!-- Audi column -->
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="mainEntityApproval"
                        :disabled="!(globals.isAdminUser || globals.isAudiUser || (globals.isLeadAgencyUser && allChecksAreLeadAgencyPlus && userAgencyEqualsCheckAgency)) || highestSurveyInstanceStatusId > 200"
                        @change="updateApprovalState('mainEntity')"
                        :class="{
                          'option-green': mainEntityApproval === 'Approved',
                          'option-red': mainEntityApproval === 'Rejected',
                          'option-yellow': mainEntityApproval === undefined,
                        }"
                      >
                      <option :value="null"></option>
                        <option
                          class="option-green"
                          :value="'Approved'"
                        >
                          {{ lang.SAM022 }}
                        </option>
                        <option class="option-yellow" :value="undefined">
                          {{ lang.SAM023 }}
                        </option>
                        <option class="option-red" :value="'Rejected'">
                          {{ lang.SAM024 }}
                        </option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.SAM025 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopperMultiApprovalModal",
  props: {
    checks: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      leadAgencyApproval: null,
      mainEntityApproval: null,
      lang: {
        SAM000: "Shopper Approval",
        SAM001: "Shopper",
        SAM002: "Messages",
        SAM003: "Lead Approval",
        SAM004: "Audi / Lead PLUS Approval",
        SAM005: "ShopperID",
        SAM006: "Name",
        SAM007: "Age",
        SAM008: "Gender",
        SAM009: "Distance",
        SAM010: "Profession",
        SAM011: "Model",
        SAM012: "Segment",
        SAM013: "Car",
        SAM014: "Match",
        SAM015: "Downgrade",
        SAM016: "Match",
        SAM017: "Upgrade",
        SAM018: "Last update",
        SAM019: "Agency Channel",
        SAM020: "Audi / Lead agency PLUS Channel",
        SAM021: "Conversation",
        SAM022: "approved",
        SAM023: "open",
        SAM024: "rejected",
        SAM025: "Close",
        SAM026: "Approval updated",
        SAM027: "Approval update failed",
        SAM028: "Shopper already checked the same location in the past!",
        SAM029: "Error while getting shopper who previous visited",
        SAM030: "Competitor Model:",
      },
    };
  },
  computed: {
    allChecksAreLeadAgencyPlus() {
      var res = true;
      this.checks.forEach(check => {
        if(!check.IsLeadAgencyPlus) {
          res = false;
          return;
        }
      });
      return res;
    },
    allChecksAreOfSameLeadAgency() {
      var res = true;
      var firstAgencyGuid = this.checks[0].LeadAgencyGuid;
      this.checks.forEach(check => {
        if(check.LeadAgencyGuid != firstAgencyGuid) {
          res = false;
          return;
        }
      });
      return res;
    },
    userAgencyEqualsCheckAgency() {
      if(this.allChecksAreOfSameLeadAgency && this.checks[0].LeadAgencyGuid) {
        if(this.globals.userAgencyGuid.toLowerCase() == this.checks[0].LeadAgencyGuid.toLowerCase()) return true;        
      } 
      return false;
    },
    highestSurveyInstanceStatusId() {
      var res = this.checks[0].SurveyInstanceStatusId;
      this.checks.forEach(check => {
        if(check.SurveyInstanceStatusId > res) {
          res = check.SurveyInstanceStatusId;
        }
      });
      return res;
    },
    anyMainEntityApprovalStatusSet() {
      var res = this.checks[0].SurveyInstanceStatusId;
      this.checks.forEach(check => {
        if(check.SurveyInstanceStatusId > res) {
          res = check.SurveyInstanceStatusId;
        }
      });
      return res;
    }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  created() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
  },
  mounted() {
    this.openModal();

    $("#shopperApprovalModal").on("hidden.bs.modal", (e) =>
      this.$emit("modalClosed")
    );
  },
  methods: {
    async openModal() {
      // await this.getPreviousVisits();
      // this.getLastFeedComments();
      // this.check.isWaveLeadAgencyPlus = await this.globals.isWaveLeadAgencyPlus(
      //   this.check.WaveGuid
      // );
      // for (var i = 0; i < this.check.ShopperProposals.length; i++) {
      //   this.check.ShopperProposals[i].ShopperPreviousVisited =
      //     this.shopperAlreadyChecked(
      //       this.check.ShopperProposals[i].ShopperGuid
      //     );
      // }
      // this.$forceUpdate();
      $("#shopperApprovalModal").modal("show");
    },
    closeModal() {
      $("#shopperApprovalModal").modal("hide");
    },
    async updateApprovalState(approvalSource) {
      for (var check of this.checks) {
        let query = `api/Approval/ShopperApproval/${check.ShopperProposals[0].ShopperProposalGuid}`;
        let body = {
          ShopperApprovalType: "Reset",
          ShopperApprovalSource: approvalSource,
        };
        let approvalState;
        if (approvalSource === "leadAgency") {
          approvalState = this.leadAgencyApproval;
          //proposal.MainEntityApprovalStatus = proposal.AgencyApprovalStatus;
        } else {
          approvalState = this.mainEntityApproval;
          //Fix for lead agency plus wave
          if (
            !this.globals.isAudiUser &&
            check.isWaveLeadAgencyPlus &&
            approvalState != "Rejected"
          ) {
            check.ShopperProposals[0].AgencyApprovalStatus = check.ShopperProposals[0].MainEntityApprovalStatus;
          }
          ////Fix for Audi user maybe we need on else if for lead agency PLUS
          ////proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
        }

        if (approvalState === "Approved") body.ShopperApprovalType = "Approve";
        else if (approvalState === "Rejected")
          body.ShopperApprovalType = "Reject";
        await $.ajax({
          method: "POST",
          url: query,
          data: JSON.stringify(body),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              this.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              this.$emit("resetData");
              return;
            }
            // if (
            //   this.globals.isAudiUser &&
            //   proposal.AgencyApprovalStatus != "Approved"
            // ) {
            //   proposal.AgencyApprovalStatus = proposal.MainEntityApprovalStatus;
            //   this.$emit("resetData");
            // }
            this.$emit("resetData");
            this.globals.showSuccessSnackbar(this.lang.SAM026);
            this.$forceUpdate();
          },
          error: (error) => {
            console.error("Error on POST in updateApprovalState()");
            this.globals.showErrorSnackbar(this.lang.SAM027);
            this.$emit("resetData");
          },
        });
      };
    },
    updateShopperProposalCarModelAndMatch(proposal) {
      $.ajax({
        method: "GET",
        url: "api/Approval/UpdateShopperProposalCarModelAndMatch",
        data: { 
          "shopper-proposal-guid": proposal.ShopperProposalGuid, 
          "car-model-guid": proposal.CarModelGuid, 
          "car-match": proposal.CarMatch,
          "competitor-car-model-guid": proposal.CompetitorCarModelGuid
        },
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar("Approval updated.");
        },
        error: (error) => {
          console.error("Error on POST in updateShopperProposalCarModelAndMatch()");
          this.globals.showErrorSnackbar(error);
        },
      });
    }
  },
};
</script>

<style scoped>
.modal-lg {
  width: 1200px;
}
.modal-body {
  padding: 10px;
}
.modal-body > .table-container {
  max-height: calc(100vh - 175px);
  overflow: auto;
}

.table td > .form-group {
  margin: 0 15%;
}
.option-green {
  background-color: rgb(154, 236, 154) !important;
}
.option-yellow {
  background-color: rgb(228, 228, 110) !important;
}
.option-red {
  background-color: rgb(238, 155, 155) !important;
}
.form-group > select.form-control {
  border-radius: 5px;
}
.form-group > select.form-control:disabled {
  opacity: 0.7;
}

.table .btn {
  margin: 5px;
  padding: 2px 10px;
}
.comment-type-header {
  font-weight: bold;
  color: #004080;
  cursor: pointer;
}
.comment-type-container {
  border: 2px solid lightgray;
  border-radius: 10px;
  padding: 5px;
  margin-bottom: 10px;
  text-align: center;
}
.last-comment-container {
  margin-top: 5px;
  padding: 2px 5px;
  border: 1px solid lightgray;
  border-radius: 5px;
  min-height: 50px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// ShopperMultiApprovalModal.vue?eca26a0a